<template>
    <section class="">
      <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
      <DataTable
        :value="transportationDetailsDetails"
        :paginator="true"
        :rows="10" :filters="filters"
        class="p-datatable-responsive p-datatable-gridlines"
        data-key="id"
      >
        <Column header="S.N">
          <template #body="slotProps">
            {{slotProps.index+1}}
          </template>
        </Column>
        <Column header="Name" field="name" filterMatchMode="contains" :sortable="true">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['name']"/>
          </template>
        </Column>
    
        <Column header="Route" field="route" filterMatchMode="contains" :sortable="true">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['route']"/>
          </template>
        </Column>
  
        <Column header="Address" field="address" filterMatchMode="contains" :sortable="true">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
          </template>
        </Column>
        <Column header="Contact Person" field="contactPerson" filterMatchMode="contains" :sortable="true">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['contactPerson']"/>
          </template>
        </Column>
        <!-- <Column header="Contact Number From" field="contactNumberFrom" filterMatchMode="contains" :sortable="true">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['contactNumberFrom']"/>
          </template>
        </Column>

        <Column header="Contact Number To" field="contactNumberTo" filterMatchMode="contains" :sortable="true">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['contactNumberTo']"/>
          </template>
        </Column> -->
        <template #empty>No record found</template>
        <Column header="Action">
          <template #body="slotProps">
            <Button type="button" class="p-button-raised p-button-success"
                    @click="editTransportationDetails(slotProps.data)" icon="pi pi-pencil"/>
            <Button type="button" class="p-button-raised p-button-success"
                    @click="viewTransportationDetails(slotProps.data)" icon="pi pi-eye"/>
            <Button class="p-button-raised p-button-danger" v-if="!slotProps.data.systemOnly"
                    @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
            <Button class="p-button-raised p-button-danger"
                    v-else @click="openDialog(slotProps.data.id)" icon="pi pi-trash" disabled/>
          </template>
        </Column>
      </DataTable>
        </div>
        </div>
      <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteTransportationDetails"/>
    </section>
  </template>
  <script>
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  import Dialog from '../../layout/dialog'
  import InputText from 'primevue/inputtext'
  import Button from 'primevue/button'
  
  export default {
    name: 'billSundaryList',
    data() {
      return {
        dialogShow: false,
        accountId: '',
        filters: {}
      }
    },
    components: {
      DataTable,
      Column,
      Dialog,
      InputText,
      Button
    },
    computed: {
      transportationDetailsDetails() {
        return this.$store.state.accountMaster.transportationDetailsDetails
      }
    },
    mounted() {
      this.transportationDetailsDetail()
    },
    methods: {
      async transportationDetailsDetail() {
        await this.$store.dispatch('loadTransportationDetailsList')
      },
      async deleteTransportationDetails(value) {
        if (value.trim() === '') {
          let message = {
            message: 'Delete reason cannot be empty.',
            messageType: 'error'
          }
          this.dialogShow = true
          this.$emit('delete-message', message)
          return
        }
        let deleteRe = {
          id: this.accountId,
          deleteReason: value
        }
        let resp = await this.$store.dispatch('deleteTransportation', deleteRe)
        if (resp.data.status === 'SUCCESS') {
          let message = {
            message: resp.data.message,
            messageType: 'success'
          }
          this.$emit('delete-message', message)
        } else {
          this.show = true
          this.setTimeInterval()
          let message = {
            message: resp.data.message,
            messageType: 'warn'
          }
          this.$emit('delete-message', message)
        }
        this.closeDialog()
      },
      editTransportationDetails(data) {
        this.$emit('edit-transportation', data)
      },
      viewTransportationDetails(data) {
        this.$emit('view-transportation', data)
      },
      cancel(data) {
        this.dialogShow = false
      },
      openDialog(id) {
        this.dialogShow = true
        this.accountId = id
      },
      closeDialog() {
        this.dialogShow = false
      }
    }
  }
  </script>
  
  <style>
  .p-datatable table {
    border-collapse: collapse;
    width: 100%;
    table-layout: auto;
    column-gap: inherit;
  }
  </style>



// WEBPACK FOOTER //
// transportationDetailsList.vue?41630fae